import EmojiPicker, { EmojiClickData, PickerProps } from "emoji-picker-react";

interface CustomEmojiPickerProps<T extends string> extends PickerProps {
  value: T;
  onChange: (v: T) => void;
}

/**
 * @description emoji Picker to handle emoji selection with prev messages
 * @link [https://www.npmjs.com/package/emoji-picker-react]
 *
 * @author Rajkumar Rathod
 */
const CustomEmojiPicker = <T extends string>({
  value,
  onChange,
  ...others
}: CustomEmojiPickerProps<T>) => {
  const onEmojiClick = (e: EmojiClickData) => {
    const valWithEmoji = (value + e.emoji) as T;

    onChange(valWithEmoji);
  };

  return <EmojiPicker open onEmojiClick={onEmojiClick} {...others} />;
};

export default CustomEmojiPicker;
